import { Component, Input, Output, EventEmitter, Directive, HostListener } from '@angular/core';
import { Options } from '@angular-slider/ngx-slider';
import { fraction, longDecimals, nFormatter, toFixed, toFixedDown, truncateDecimals } from 'src/app/lib/roundOf';
import { PairFacade } from 'src/app/store/botpair';
import { ActivatedRoute, Router } from '@angular/router';
import { GridBotService } from 'src/app/services/bot.grid.service';
import { TradePairFacade } from 'src/app/store/bottradepair';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthFacade } from 'src/app/store/auth';
import { WalletService } from 'src/app/services/wallet.service';
import { TradeAssetFacade } from 'src/app/store/bot-trade-asset';
import isEmpty from 'src/app/lib/isEmpty';
import { ToastrService } from 'ngx-toastr';
import { PositionDetailsFacade } from 'src/app/store/positionDetails';
import { MarketPriceFacade } from 'src/app/store/marketprice';
import { SocketService } from 'src/app/services/socket.service';

interface SymbolMeta {
  price: number;
  tickSize: number;
  stepSizeQty: number;
  minNotional: number;
  priceDecimals: number;
  qtyDecimals: number;
}

interface OrderLevel {
  price: number;
  qty: number;
  notional: number;
}

interface DefaultGridConfig {
  symbol: string;
  currentPrice: string;
  stepPercent: number;
  ratio: number;
  gridLevels: number;
  lowPrice: string;
  highPrice: string;
  minNotional: number;
  stepSizeQty: number;
  priceDecimals: number;
  qtyDecimals: number;
  buyOrders: OrderLevel[];
  sellOrders: OrderLevel[];
  usdtForBuys: number;
  btcForSells: number;
  btcForSellsInUSDT: number;
  totalRequiredUSDT: number;
  buyPercentage: number;
  buyCount: number;
  sellPercentage: number;
  sellCount: number;
  profitPercentage: number;
  buyProfitPercentage: number;
}

interface ValidateGridConfigResult extends Omit<DefaultGridConfig, 'buyOrders' | 'sellOrders'> {
  userInvestment: number;
  isValid: boolean;
  deficit: number;
  buyOrders: OrderLevel[];
  sellOrders: OrderLevel[];
}

@Component({
  selector: 'app-gridbotcreate',
  templateUrl: './gridbotcreate.component.html',
  styleUrls: ['./gridbotcreate.component.css']
})

export class GridbotcreateComponent {
  @Input() botDetails: any;
  @Output() orderStep: any
  @Output() gotoStep = new EventEmitter<any>();
  onWheel(event: WheelEvent) {
    event.preventDefault(); // Prevents the default scroll behavior
  }

  sliderVal: number = 0;
  isChecked: boolean = false;
  isChecked2: boolean = false;
  isManual: boolean = false;
  value: number = 100;
  options: Options = {
    floor: 0,
    ceil: 200
  };
  amountMultiplier: number = 100;
  amountMultiplierOptions: Options = {
    floor: 0,
    ceil: 200
  };
  stepMultiplier: number = 100;
  stepMultiplierOptions: Options = {
    floor: 0,
    ceil: 200
  };
  toFixedDown = toFixedDown
  toFixed = toFixed
  truncateDecimals = truncateDecimals
  longDecimals = longDecimals
  fraction = fraction
  nFormatter = nFormatter

  pairs: any = {}
  wallet: any = {}
  tradedata: any = {}
  loader = false
  createDetails = {}
  orderPlaceDet = {}
  auth: any = {}
  searchPair: string = ''
  pairData: any = {}
  formValue: any = {
    investment: 0,
    upperPrice: 0,
    lowerPrice: 0,
    grids: 5,
    isGridStepPercent: true,
    gridStepPercent: 0,
    gridStepValue: 25,
    orders: [],
    profitType: 'arithmetic',
    autoAdd: false,
    takeprofitRatio: 2,
    takeprofitCallback: 0,
    stopLoss: 1,
    isstoploss: false,
    total: ['']
  }
  minGrid: number = 2
  maxGrid: number = 20
  isSubmitting = false;
  showNext = false
  // form: FormGroup
  serverErrors: any = {}
  inputFields: any = []
  usdPrice: any = 0.9999
  constructor(
    private _fb: FormBuilder,
    private pairFacade: PairFacade,
    private botFacade: TradePairFacade,
    private router: Router,
    private route: ActivatedRoute,
    private service: GridBotService,
    private authFacade: AuthFacade,
    private walletService: WalletService,
    private tradeAssetFacade: TradeAssetFacade,
    private positionDetails: PositionDetailsFacade,
    private toastr: ToastrService,
    private markPrice: MarketPriceFacade,
    private socketService: SocketService,

  ) {
    this.authFacade.auth$.subscribe({
      next: (userAuth: any) => {
        this.auth = userAuth
      },
      error: (err: any) => { }
    })
  }
  ngOnInit() {
    this.getPairs()
    this.getSinglePair()
    this.getWallet()
    this.showNext = false
  }


  getPairs() {
    this.pairFacade.pair$.subscribe({
      next: (pair: any) => {
        this.pairs = pair
      },
      error: (err: any) => { }
    })
  }
  getWallet() {
    this.tradeAssetFacade.tradeAsset$.subscribe({
      next: (asset: any) => {
        this.wallet = asset.secondCurrency
        let setInvestment = 0
        let buyPerc = 40
        let buyCount = 20
        let sellPerc = 60
        let sellCount = 3
        let profitPercentage = 0
        let buyProfitPercentage = 0
        if (parseFloat(this.wallet?.gridBal) < 1000) {
          setInvestment = parseFloat(this.wallet?.gridBal)
        } else {
          setInvestment = 1000
        }
        if (setInvestment)
          this.formValue = {
            ...this.formValue, ...{
              investment: toFixedDown(setInvestment, 4),
              buyPercentage: toFixedDown(buyPerc, 4),
              buyCount: toFixedDown(buyCount, 4),
              sellPercentage: toFixedDown(sellPerc, 4),
              sellCount: toFixedDown(sellCount, 4),
              profitPercentage: toFixedDown(profitPercentage, 4),
              buyProfitPercentage: toFixedDown(buyProfitPercentage, 4),
            }
          };
        this.getDefaultGridConfig();
      },
      error: (err: any) => { }
    })
  }
  getSinglePair() {
    this.botFacade.tradePair$.subscribe({
      next: (pair: any) => {
        this.pairData = pair
      },
      error: (err: any) => { }
    })
    this.markPrice.marketPrice$.subscribe({
      next: (v: any) => {
        this.pairData = { ...this.pairData, ...v }
        if (v?.markPrice && this.formValue?.upperPrice == 0)
          this.getDefaultGridConfig();
      },
      error: (err: any) => { }
    })
  }

  //search
  handleSearchPair(event: any) {
    this.searchPair = event.target.value.toUpperCase().replace('/', '')
  }
  changePair(pair: any) {
    const newPair = pair.firstCurrencySymbol + '_' + pair.secondCurrencySymbol
    const activePair = this.route.snapshot.params['tikerRoot']
    if (newPair == activePair) return;
    this.socketService.emit("unSubscribe", activePair.replace("_", ""));
    // this.socketService.emit("subscribe", newPair.replace("_", ""));
    // this.router.navigateByUrl('/gridbot/' + newPair)
    // this.service.setTradePair(pair)
    // this.markPrice.setSpotMarketPrice(pair)
    // this.positionDetails.setPosition({})
    // this.fetchAssetByCurrency(pair.secondCurrencyId, 'secondCurrency')
    window.location.href = '/gridbot/' + newPair
  }

  fetchAssetByCurrency(spotPairId: string, type: 'firstCurrency' | 'secondCurrency') {
    if (!this.auth.signedIn) {
      return
    }
    this.walletService.getAssetByCurrency(spotPairId)
      .subscribe({
        next: (v: any) => {
          if (v.success) {
            if (type === 'firstCurrency')
              this.tradeAssetFacade.setFirstCurrency(v.result)
            else if (type === 'secondCurrency')
              this.tradeAssetFacade.setSecondCurrency(v.result)
          }
        },
        error: (err: any) => {
        }
      })
  }

  //from
  submitForm(): any {
    try {

      const errors: any = {};

      const investment = parseFloat(this.formValue?.investment) || 0;
      const buyPercentage = parseFloat(this.formValue?.buyPercentage) || 0;
      const sellPercentage = parseFloat(this.formValue?.sellPercentage) || 0;
      const profitPercentage = parseFloat(this.formValue?.profitPercentage) || 0;
      const buyProfitPercentage = parseFloat(this.formValue?.buyProfitPercentage) || 0;
      const buyCount = parseFloat(this.formValue?.buyCount) || 0;
      const sellCount = parseFloat(this.formValue?.sellCount) || 0;
      const walletBal = parseFloat(this.wallet?.gridBal) || 0;

      // 🧩 1️⃣ Basic required validations
      if (investment <= 0) errors.investment = "Required";
      else if (investment > walletBal) errors.investment = "Insufficient Balance";

      if (buyPercentage <= 0) errors.buyPercentage = "Required";
      if (sellPercentage <= 0) errors.sellPercentage = "Required";
      if (profitPercentage <= 0) errors.profitPercentage = "Required";
      if (buyProfitPercentage <= 0) errors.buyProfitPercentage = "Required";
      if (buyCount <= 0) errors.buyCount = "Required";
      if (sellCount <= 0) errors.sellCount = "Required";

      // 🧮 2️⃣ Buy/Sell percentage total validation
      if (buyPercentage + sellPercentage !== 100) {
        errors.buyPercentage = "Buy % and Sell % must total 100%";
      }

      // 🪙 3️⃣ Minimum order validation
      const fullPair = this.pairs.find((v: any) => v._id === this.pairData._id);
      if (!fullPair) {
        this.toastr.error("Invalid pair");
        return false;
      }

      const minOrderValue = parseFloat(fullPair?.minOrderValue) || 0;

      if (minOrderValue && investment < minOrderValue) {
        errors.investment = `Minimum investment is ${minOrderValue}`;
      }

      // 📊 4️⃣ Calculate each order value
      const totalBuyValue = investment * (buyPercentage / 100);
      const totalSellValue = investment * (sellPercentage / 100);
      const buyOrderValue = buyCount > 0 ? totalBuyValue / buyCount : 0;
      const sellOrderValue = sellCount > 0 ? totalSellValue / sellCount : 0;

      if (buyCount > 0 && buyOrderValue < minOrderValue) {
        errors.buyCount = `Each Buy Order Value (${buyOrderValue.toFixed(2)}) must be at least ${minOrderValue}.`;
      }

      if (sellCount > 0 && sellOrderValue < minOrderValue) {
        errors.sellCount = `Each Sell Order Value (${sellOrderValue.toFixed(2)}) must be at least ${minOrderValue}.`;
      }

      // 🚨 5️⃣ Return all errors together
      if (Object.keys(errors).length > 0) {
        this.serverErrors = errors;
        return false;
      }

      if (this.formValue?.investment > parseFloat(this.wallet?.gridBal)) {
        this.toastr.error(`Insufficient balance`)
        return false
      }
      if (fullPair?.minInvestment > this.formValue.investment)
        return this.serverErrors = { ...this.serverErrors, investment: `Minimum investment is ${fullPair?.minInvestment} ${fullPair.secondCurrencySymbol}` };

      this.isSubmitting = true;
      let formValue = this.formValue
      let pairName = `${this.pairData.firstCurrencySymbol}${this.pairData.secondCurrencySymbol}`;
      let genDet = {
        pairName: `${this.pairData.firstCurrencySymbol}-${this.pairData.secondCurrencySymbol}`,
        investment: parseFloat(formValue.investment),
        upperPrice: parseFloat(formValue.upperPrice),
        lowerPrice: parseFloat(formValue.lowerPrice),
        buyPercentage: parseFloat(formValue.buyPercentage),
        buyCount: parseFloat(formValue.buyCount),
        sellPercentage: parseFloat(formValue.sellPercentage),
        sellCount: parseFloat(formValue.sellCount),
        buyProfitPercentage: parseFloat(formValue.buyProfitPercentage),
        profitPercentage: parseFloat(formValue.profitPercentage),
        grids: parseFloat(formValue.grids),
        gridStepValue: formValue.gridStepValue,
        isGridStepPercent: formValue?.isGridStepPercent ?? false,
        gridStepPercent: parseFloat(formValue.gridStepPercent),
        orders: formValue.orders,
        profitType: formValue.profitType,
        autoAdd: formValue.autoAdd,
        takeProfit: parseFloat(formValue.takeprofitRatio),
        takeprofitCallback: parseFloat(formValue.takeprofitCallback),
        stopLoss: parseFloat(formValue.stopLoss),
        isstoploss: this.isChecked2,
        istakeProfit: this.isChecked,
        // total: formValue.total.map((v: any) => parseFloat(v)),
        firstCurrencySymbol: this.pairData.firstCurrencySymbol,
        secondCurrencySymbol: this.pairData.secondCurrencySymbol,
        isManual: this.isManual

      }
      this.createDetails = genDet
      let reqData = {
        pairName: pairName,
        pairId: this.pairData._id,
        exchange: this.pairData.botstatus,
        BotType: "GRID",
        RunStatus: false,
        tradesetting: genDet,
        orderType: "Limit",
        validate: true
      };

      this.service.botValidation(reqData).subscribe({
        next: (v: any) => {

          reqData.validate = false
          this.createDetails = genDet
          this.orderPlaceDet = reqData
          this.isSubmitting = false;
          // this.gotoStep.emit("two")
          this.orderStep = "two"
          this.showNext = true
        },
        error: (err: any) => {
          this.isSubmitting = false;

          reqData.validate = false

          if ([400, 404].includes(err.status)) {
            const validationErrors = err.error.errors;
            if (!isEmpty(validationErrors)) {
              this.serverErrors = validationErrors || {};
              this.toastr.error(err.error.message)
              if (err?.error?.order) {
                this.toastr.error(err.error.order)
              }
            }
          } else if (err.status === 500) {
            this.toastr.error(err.error.message);
          }
        },
        complete: () => { },
      });
      return false
    } catch (err) {
      console.log(err, "submitFormsubmitForm");
      this.isSubmitting = false;
      return false
    }
  };
  navigateToLogin() {
    this.router.navigateByUrl('signin')
  }
  handleTradeChange(e: any): void {
    e.preventDefault()
    let { name, value } = e.target
    if (
      ["investment", "upperPrice", "lowerPrice", "grids", "gridStepPercent", "gridStepValue", "takeprofitRatio",
        "takeprofitCallback", "stopLoss", "buyPercentage", "buyCount", "sellPercentage", "sellCount"].includes(name)
    ) {
      //number 
      const isValidFloat = /^(\d+)?(\.\d{0,10})?$/.test(value) || value === '' || value === '.';
      if (!isValidFloat) return
    }

    if (['buyPercentage', "sellPercentage"].includes(name)) {
      if (name == 'buyPercentage') {
        let allowVal = 100 - parseFloat(this.formValue.sellPercentage)
        if (value > allowVal) {
          e.target.value = allowVal;
          value = allowVal;
        }
      }
      if (name == 'sellPercentage') {
        let allowVal = 100 - parseFloat(this.formValue.buyPercentage)
        if (value > allowVal) {
          e.target.value = allowVal;
          value = allowVal;
        }
      }
    }
    //number 
    // cur decimals based on binance
    if (["upperPrice", "lowerPrice", "gridStepValue", "investment"].includes(name)) value = toFixedDown(value, this.pairData?.secondFloatDigit)
    // if (["investment"].includes(name)) value = toFixedDown(value, this.pairData?.secondFloatDigit)

    this.formValue = { ...this.formValue, ...{ [name]: value } };
    if (value) {
      this.serverErrors = { ...this.serverErrors, ...{ [name]: "" } };
      this.loader = false;
    }

    //calculate grid setting
    if (name == "investment" || name == "gridStepValue" || name == "grids")
      this.getDefaultGridConfig()

  }

  filterFloatKeydown(event: KeyboardEvent, fieldName: string): void {
    const allowedKeys = [
      'Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete', 'Home', 'End'
    ];
    // allow navigation, shortcuts, etc.
    if (
      allowedKeys.includes(event.key) ||
      event.ctrlKey ||
      event.metaKey
    ) {
      return;
    }

    // only digits or dot
    if (!/^[0-9.]$/.test(event.key)) {
      event.preventDefault();
      return;
    }

    // determine how many decimals we can have
    let decimalLimit = 6;
    if (["upperPrice", "lowerPrice", "investment", "gridStepValue"].includes(fieldName)) {
      decimalLimit = parseInt(this.pairData.secondFloatDigit) ?? 6;
    } else if (fieldName === "grids") {
      decimalLimit = 0;
    }

    const input = event.target as HTMLInputElement;
    const { selectionStart: start, selectionEnd: end, value } = input;
    if (start === null || end === null) {
      // fall back to default
      return;
    }

    // build what the new value *would* be
    const before = value.slice(0, start);
    const after = value.slice(end);
    const newValue = before + event.key + after;

    // regex: any number of digits, optionally a dot followed by up to decimalLimit digits
    const re = new RegExp(`^\\d*(?:\\.\\d{0,${decimalLimit}})?$`);

    if (!re.test(newValue)) {
      event.preventDefault();
      return;
    }
  }



  handleBSChange(event: any) {
    const { name, value } = event.target;
    let slvaluemanual = toFixedDown(
      (parseFloat(value) / parseFloat(this.wallet?.gridBal)) * 100,
      2
    );
    this.sliderVal = slvaluemanual
    this.formValue({
      [name]: value,
      convertPrice: toFixedDown(
        parseFloat(value) *
        parseFloat(this.usdPrice),
        2
      )
    });
  };
  onSliderChange(newValue: number) {
    let balanceinEx = parseFloat(this.wallet?.gridBal);
    let value = toFixedDown(
      (balanceinEx * newValue) / 100
    )
    this.sliderVal = newValue
    this.formValue = {
      ...this.formValue, ...{
        investment: value,
        convertPrice: toFixedDown(
          parseFloat(value) *
          parseFloat(this.usdPrice),
          2
        )
      }
    };
  }

  handlestopLoss(e: any) {
    this.formValue = { ...this.formValue, ...{ ['isstoploss']: e.target.checked } }
  };


  // ---------- Helpers ----------
  getTickAndStepSizes(priceDecimals: number, qtyDecimals: number) {
    const tickSize = Number((1 / Math.pow(10, priceDecimals)).toFixed(priceDecimals));
    const stepSizeQty = Number((1 / Math.pow(10, qtyDecimals)).toFixed(qtyDecimals));

    return { tickSize, stepSizeQty };
  }
  roundUpToStep = (v: number, step: number) => Math.ceil(v / step) * step;
  roundDownToStep = (v: number, step: number) => Math.floor(v / step) * step;
  getDecimals = (step: number) => Math.max(0, -Math.log10(parseFloat(step.toString()) || 1));

  // Price rounding: floor for BUY (not to exceed), ceil for SELL (not to undersell)
  roundBuyPrice = (p: number, tick: number) => this.roundDownToStep(p, tick);
  roundSellPrice = (p: number, tick: number) => this.roundUpToStep(p, tick);


  // ---------- Types ----------


  // ---------- API Helpers ----------
  getSymbolMeta(fullPair: any) {

    const priceDecimals = parseFloat(fullPair?.secondFloatDigit);
    const qtyDecimals = parseFloat(fullPair?.firstFloatDigit);
    const minNot = parseFloat(fullPair.minOrderValue);
    const price = parseFloat(fullPair.markPrice);
    const { tickSize, stepSizeQty } = this.getTickAndStepSizes(priceDecimals, qtyDecimals);

    return {
      price,
      tickSize,
      stepSizeQty,
      minNotional: minNot,
      priceDecimals,
      qtyDecimals,
    };
  }

  // Build geometric grid around current price
  buildGridPrices({
    currentPrice, grids, stepPercent, tickSize
  }: {
    currentPrice: number;
    grids: number;
    stepPercent: number;
    tickSize: number;
  }) {
    const r = 1 + (stepPercent / 100);
    const below = Math.floor(grids / 2);
    const above = grids - below;
    const buys = [];
    for (let i = below; i >= 1; i--) {
      const raw = currentPrice / Math.pow(r, i);
      buys.push(this.roundBuyPrice(raw, tickSize));
    }
    // Prices above current (SELL levels)
    const sells = [];
    for (let i = 1; i <= above; i++) {
      const raw = currentPrice * Math.pow(r, i);
      sells.push(this.roundSellPrice(raw, tickSize));
    }

    return { buyPrices: buys, sellPrices: sells, ratio: r };
  }

  // ---------- Main Functions ----------
  getDefaultGridConfig() {

    const fullPair = this.pairs.find((v: any) => v._id == this.pairData._id);
    if (!fullPair) return;

    let symbol = parseFloat(fullPair?.tikerRoot)
    let gridLevels = parseFloat(this.formValue?.grids)
    let userInvestment = parseFloat(this.formValue?.investment)
    let profitPercent = 0.5
    let feePercent = parseFloat(fullPair?.bot_taker_fees ?? fullPair?.taker_fees ?? 0.1)
    let safetyBuffer = 1.05

    if (gridLevels < 2) throw new Error('gridLevels must be at least 2');

    const meta: any = this.getSymbolMeta(fullPair);
    const { price: currentPrice, tickSize, stepSizeQty, minNotional, priceDecimals, qtyDecimals } = meta;
    const stepPercent = profitPercent + (feePercent);
    const stepValue = currentPrice * (stepPercent / 100);
    const { buyPrices, sellPrices, ratio: stepValueActual } = this.buildGridPrices({
      currentPrice,
      grids: gridLevels,
      stepPercent,
      tickSize
    });
    let oneOrdeInvestment = userInvestment / gridLevels

    let usdtForBuys = 0;
    const buyOrders: any[] = buyPrices.map(p => {
      let price = truncateDecimals(p, priceDecimals)
      const qtyRaw = oneOrdeInvestment / price;
      const qty = truncateDecimals(qtyRaw, qtyDecimals);
      const notional = qty * price;
      usdtForBuys += notional;
      const orderValue = p * qtyRaw;
      return { price: p, quantity: parseFloat(qty), notional, side: 'buy', orderValue };
    });

    let btcForSells = 0;
    const sellOrders: any[] = sellPrices.map(p => {
      let price = truncateDecimals(p, priceDecimals)
      const qtyRaw = oneOrdeInvestment / price;
      const qty = truncateDecimals(qtyRaw, qtyDecimals);
      btcForSells += qty;
      const orderValue = price * qty;
      return { price: p, quantity: parseFloat(qty), notional: qty * p, side: 'sell', orderValue };
    });
    console.log(oneOrdeInvestment, "userInvestment", currentPrice, "buyOrders", buyOrders, "sellOrders", sellOrders)
    const totalRequiredUSDT = usdtForBuys + btcForSells * currentPrice;

    const low = buyPrices.length ? buyPrices[0] : currentPrice;
    const high = sellPrices.length ? sellPrices[sellPrices.length - 1] : currentPrice;

    this.formValue = {
      ...this.formValue,
      lowerPrice: low.toFixed(priceDecimals),
      upperPrice: high.toFixed(priceDecimals),
      grids: gridLevels,
      gridStepValue: truncateDecimals(stepValue, priceDecimals),
      gridStepPercent: stepValueActual,
      orders: [...buyOrders, ...sellOrders]
    };
  }



  validateGridConfig(changedField: String) {
    let lowPrice = this.formValue.lowerPrice
    let highPrice = this.formValue.upperPrice
    let gridLevels = this.formValue?.grids ?? 5;
    let gridStepValue = this.formValue.gridStepValue

    let profitPercent = 0.5;
    let feePercent = 0.2;
    let floatDigits = 6;
    let marketPrice = 0
    let minInvestment = 10
    let maxOrderValue = 10
    let minOrderValue = 10
    let userInvestment = parseFloat(this.formValue?.investment ?? 0);

    const fullPair = this.pairs.find((v: any) => v._id == this.pairData._id);
    if (!fullPair) return;
    if (fullPair?.secondFloatDigit) floatDigits = fullPair.secondFloatDigit;
    if (fullPair?.taker_fees) feePercent = parseFloat(fullPair?.bot_taker_fees ?? fullPair?.taker_fees ?? 0.1);
    if (fullPair?.markPrice) marketPrice = parseFloat(fullPair.markPrice);
    if (fullPair?.minInvestment) minInvestment = parseFloat(fullPair.minInvestment);
    if (fullPair?.maxOrderValue) maxOrderValue = parseFloat(fullPair.maxOrderValue);
    if (fullPair?.minOrderValue) minOrderValue = parseFloat(fullPair.minOrderValue);

    const stepPercent = profitPercent + (feePercent * 2);

    let stepSizePrice: number = 0;

    if (changedField === 'investment') {
      // 1️⃣ Investment given → calculate step size
      stepSizePrice = marketPrice * (stepPercent / 100)
    } else if (changedField === 'gridStepValue') {
      // 2️⃣ Step size given → recalculate investment
      stepSizePrice = parseFloat(this.formValue?.gridStepValue ?? 0);
      // Optionally recalc investment if needed
    }
    lowPrice = marketPrice - stepSizePrice * ((gridLevels / 2) + 1)
    highPrice = marketPrice + stepSizePrice * ((gridLevels / 2) + 1)

    // 7. Final validations
    if (lowPrice <= 0 || isNaN(lowPrice)) {
      return this.serverErrors = { ...this.serverErrors, lowerPrice: "Invalid lower price" };
    }
    if (highPrice <= 0 || isNaN(highPrice)) {
      return this.serverErrors = { ...this.serverErrors, upperPrice: "Invalid upper price" };
    }
    if (stepSizePrice <= 0 || isNaN(stepSizePrice)) {
      return this.serverErrors = { ...this.serverErrors, gridStepValue: "Invalid step" };
    }
    if (minInvestment > userInvestment)
      return this.serverErrors = { ...this.serverErrors, investment: `Minimum investment is ${minInvestment} ${fullPair.secondCurrencySymbol}` };
    else if (minOrderValue * gridLevels > userInvestment)
      return this.serverErrors = { ...this.serverErrors, investment: `Minimum investment for ${gridLevels} grids is ${minOrderValue * gridLevels} ${fullPair.secondCurrencySymbol}` };

    this.formValue = {
      ...this.formValue,
      lowerPrice: lowPrice,
      upperPrice: highPrice,
      grids: gridLevels,
      gridStepValue: stepSizePrice,
      gridStepPercent: stepPercent
    };
    this.serverErrors = {};
  }


}

